import Stack from '@mui/material/Stack';
import type { Citation, Panel } from '../api/schemas';
import { ForecastPanel } from './ForecastPanel';
import { HouseViewPanel } from './HouseViewPanel';
import { TechnicalPanel } from './TechnicalPanel';

type Props = { panels: Panel[]; citations: Citation[] };

/** Data panels for the table facts the answer cites. Their figures come from the database, not the model. */
export function AnswerPanels({ panels, citations }: Props) {
  if (panels.length === 0) return null;
  const byNumber = new Map(citations.map((c) => [c.n, c]));
  return (
    <Stack sx={{ gap: 1.25 }}>
      {panels.map((p) => {
        const citation = byNumber.get(p.cite);
        const key = `${p.kind}-${p.cite}`;
        if (p.kind === 'forecast') return <ForecastPanel key={key} panel={p} citation={citation} />;
        if (p.kind === 'technical') return <TechnicalPanel key={key} panel={p} citation={citation} />;
        return <HouseViewPanel key={key} panel={p} citation={citation} />;
      })}
    </Stack>
  );
}
